import { ICON_FIELD } from '../elements/assets'

export const QUESTIONS = `
...on questions_Entry {
  id
  typeHandle

  heading {
    html
  }

  questions {
    ... on questionItem_Entry {
      ${ ICON_FIELD }
      textAdvanced {
        html
      }
    }
  }
}
`